<template>
  <page-container>
    <template v-slot:page-fixed-header>
      <span
        v-if="Loaderloading"
        class="text-h3 font-weight-bold ml-2 full-width"
        style="color: var(--v-secondary-darken1)"
      >
        ...
      </span>
      <in-place-editor-for-meeting-name
        v-else
        v-model="meetingObject.meetingName"
        :lable="$t('search.meetingName')"
        @contentPadding="meetingNameStyle"
      ></in-place-editor-for-meeting-name>
      <v-spacer></v-spacer>
      <meeting-navigation
        :previous-meeting-id="meetingObject.prev_meeting"
        :next-meeting-id="meetingObject.next_meeting"
        :prevTooltip="prevTooltip"
        :nextTooltip="nextTooltip"
      ></meeting-navigation>
      <v-tooltip bottom v-if="updateMeetingPermission">
        <template v-slot:activator="{ on, attrs }">
          <a-btn
            v-bind="attrs"
            v-on="on"
            v-if="updateMeetingPermission"
            class="ml-2"
            color="primaryDark"
            @click.stop="saveMeeting"
            :disabled="isMeetingSaveButtonEnabled"
          >
            <v-icon size="16" class="mr-3">mdi-content-save</v-icon
            >{{ $t("btnSave") }}</a-btn
          >
        </template>
        <span>{{ $t("btnSave") }}</span>
      </v-tooltip>

      <CloseIcon @click="onclose()" classProps="ml-2" />
    </template>
    <template v-slot:page-content>
      <div v-if="Loaderloading" :style="pageContentStyle">
        <v-col cols="12" sm="12" md="12">
          <v-skeleton-loader type="heading" class="mb-4"></v-skeleton-loader>
          <v-skeleton-loader
            type="table-heading, list-item-two-line, article, list-item"
          ></v-skeleton-loader>
          <v-skeleton-loader
            type="list-item-two-line, list-item-two-line, article, list-item"
          ></v-skeleton-loader>
        </v-col>
      </div>
      <div v-else :style="pageContentStyle">
        <v-col cols="12" sm="12" md="12" lg="12" v-if="isParticipants">
          <a @click="goToAtttendance" href="javascript:void(0)">{{
            $t("agenda.lblChooseAttendance")
          }}</a>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-expansion-panels v-model="basicInfoPanels">
            <a-expansion-panel class="meeting-basic-info-panel">
              <v-expansion-panel-header
                @click="onPanelClick"
                disable-icon-rotate
              >
                {{ $t("agenda.titleBasicInfoPanel") }}
                <template v-slot:actions>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        color="grey"
                        dark
                        icon
                        v-bind="attrs"
                        v-on="on"
                        @click="onPanelClick"
                      >
                        <v-icon v-if="basicInfoPanel">mdi-chevron-up</v-icon>
                        <v-icon v-else>mdi-chevron-down </v-icon>
                      </v-btn>
                    </template>
                    <span v-if="basicInfoPanel">{{ $t("lblCollapse") }}</span>
                    <span v-else>{{ $t("lblExpand") }}</span>
                  </v-tooltip>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-col cols="12" sm="12">
                  <in-place-text-field-editor
                    v-model.trim="meetingObject.meetingTheme"
                    icon="mdi-palette-swatch-outline"
                    :lable="$t('agenda.lblMeetingTheme')"
                    type="meetingTheme"
                  ></in-place-text-field-editor>
                </v-col>
                <v-col cols="12" sm="12">
                  <agenda-meeting-details-card
                    v-model="meetingObject"
                    :isMeetingTimeValid="isMeetingTimeValid"
                  ></agenda-meeting-details-card>
                </v-col>
                <v-col cols="12" sm="12">
                  <in-place-text-field-editor
                    v-model="meetingObject.meeting_link"
                    icon="mdi-link"
                    :lable="$t('agenda.lblMeetingLink')"
                    :maxLength="maxLinkCharLength"
                    type="meetingLink"
                  ></in-place-text-field-editor>
                </v-col>
              </v-expansion-panel-content>
            </a-expansion-panel>
          </v-expansion-panels>
        </v-col>
        <v-col cols="12" sm="12">
          <meeting-details-right-panel-template
            ref="renderRightPanel"
            v-if="meetingObject"
            :selectedMeeting="meetingObject"
            @descriptionWithImg="otherInfoDescription"
            :attendanceRows="attendanceNoteRows"
            :abstractRows="abstractRows"
          ></meeting-details-right-panel-template>
        </v-col>
      </div>
      <MessageSheet
        :showMessage="displayMessage"
        :message="message"
        :messageType="messageType"
        @close="closeMessageSheet"
        :isMeetingUpdatedMsgDeletedDoc="isMeetingUpdatMsgDeletedDoc"
      ></MessageSheet>
      <ConfirmDialog ref="confirm" />
      <email-send-confirmation
        :emailData="emailData"
        :notificationMessage="notificationMessage"
        @send="onEmailSend"
        @cancel="onEmailDialogCancel"
      ></email-send-confirmation>
      <tenant-switch-dialog ref="refSwitchDialog"></tenant-switch-dialog>
      <prevent-navigation
        :prevent="shouldPreventNavigation"
        @save="saveOnLeave"
        @discard="$event.next()"
        @cancel="cancel($event)"
      >
      </prevent-navigation>
      <meeting-email-notification
        v-if="showEmailDialog"
        v-model="showEmailDialog"
        :meetingObject="meetingObject"
        @send="onEmailSend"
        @close="onClose"
      ></meeting-email-notification>
    </template>
  </page-container>
</template>

<style scoped>
.meeting-basic-info-panel /deep/ .v-expansion-panel-content__wrap {
  padding: 12px !important;
}
.a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: var(--v-primaryDark-base) !important;
}

.meeting-action-buttons {
  display: inherit;
  justify-content: space-evenly;
}
</style>
<script>
import Vue from "vue";
import {
  InPlaceEditorPlugin,
  Rte,
  ComboBox,
  TimePicker,
  ActionEventArgs,
} from "@syncfusion/ej2-vue-inplace-editor";
import MeetingNavigation from "@/components/agenda/MeetingNavigation.vue";
import MessageSheet from "@/components/MessageSheet.vue";
import { SplitterPlugin } from "@syncfusion/ej2-vue-layouts";
import { mapState, mapActions } from "vuex";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import PreventNavigation from "@/components/PreventNavigation.vue";
import TenantSwitchDialog from "../TenantSwitchDialog.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import EmailUsersList from "./EmailUsersList.vue";
import EmailSendConfirmation from "./EmailSendConfirmation.vue";
import { Internationalization } from "@syncfusion/ej2-base";
import MeetingCard from "../../wrapper-component/MeetingCard.vue";
import FileInput from "../../wrapper-component/FileInput.vue";
import AgendaMeetingDetailsCard from "./AgendaMeetingDetailsCard.vue";
import AgendaTableNew from "./agendaTableNew.vue";
import MeetingDetailsRightPanelTemplate from "./MeetingDetailsRightPanelTemplate.vue";
import InPlaceEditorForMeetingName from "./InPlaceEditorForMeetingName.vue";
import { cloneDeep } from "lodash";
import InPlaceTextFieldEditor from "../InPlaceTextFieldEditor.vue";
import { isURL, createUUID, currentDateTime } from "../../utils/util";
import documentService from "../../api/documentService";
import ChunkFileUpload from "../../mixin/ChunkFileUpload";
import MeetingEmailNotification from "./MeetingEmailNotification.vue";
import { MEETING_LINK_CHARACTER_LENGTH } from "@/utils/constant";
import tenantConfigService from "../../api/tenantConfigService";
Vue.use(SplitterPlugin);
Vue.use(InPlaceEditorPlugin);
Vue.prototype.$eventHub = new Vue();
export default {
  name: "MeetingDetailsPage",
  mixins: [SignalRMixin, ChunkFileUpload],
  data() {
    return {
      showEmailDialog: false,
      isGeneralDocsValid: false,
      chunkUploadFilesList: [],
      generalDocuments: [],
      isTopicMovie: false,
      isDescriptionWithImg: null,
      isMeetingUpdatMsgDeletedDoc: false,
      basicInfoPanels: 0,
      basicInfoPanel: true,
      nextRoute: null,
      padding: 0,
      prevTooltip: false,
      nextTooltip: false,
      descriptionPanel: 0,
      previousMeetingId: null,
      nextMeetingId: null,
      hideSHow: true,
      emailData: {},
      notificationMessage: "",
      newDocumentsIds: [],
      newDocuments: [],
      isAttachmentSend: false,
      routeTenantId: "",
      valid: false,
      isDirty: false,
      overlay: true,
      absolute: true,
      startTime: new Date(),
      endTime: new Date(),
      opacity: 0,
      rules: [],
      displayMessage: false,
      message: "",
      messageType: "",
      updatedMeetingObj: null,
      isMeetingDataModified: false,
      meetingKey: "",
      deleteDocumentIds: [],
      deleteUsers: [],
      selectedMeeting: null,
      Loaderloading: false,
      LoaderText: this.$t("LoaderText"),
      newAgendaObjList: [],
      emailConfirmationMessage: "",
      emailNotificationRequired: false,
      intl: new Internationalization(),
      documentViews: null,
      skipUpdateMessage: false,
      isSilentRequest: false,
      maxLinkCharLength: MEETING_LINK_CHARACTER_LENGTH,
      attendanceNoteRows: 1,
      abstractRows: 2,
      currentConfig: null,
      renderRightPanel: 0,
      textValidationRules: {
        Title: {
          required: [true, this.$t("agenda.msgIsMandatory")],
          regex: [this.checkString, this.$t("agenda.msgIsMandatory")],
        },
      },
      meetingDateTimeRule: {
        ejsStartDateTime: {
          required: [true, this.$t("agenda.msgIsMandatory")],
          regex: [
            /^(1[0-2]|0?[1-9])\/(3[01]|[12][0-9]|0?[1-9])\/(?:[0-9]{2})?[0-9]{2} ([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i,
            this.$t("agenda.msgIsValidDate"),
          ],
          date: [true, this.$t("agenda.msgIsValidDate")],
        },
      },
      meetingDateRule: {
        meetingStartDate: {
          required: [true, this.$t("agenda.msgIsMandatory")],
          date: true,
        },
      },
      meetingEndDateRule: {
        ejsMeetingEndDate: {
          required: [true, this.$t("agenda.msgIsMandatory")],
          date: [true, this.$t("agenda.msgIsValidDate")],
          range: [this.compareDate, this.$t("agenda.msgIsCompareDate")],
        },
      },
      meetingTimeRule: {
        ejsMeetingStartTime: {
          required: true,
          regex: /^([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i,
        },
      },
      meetingEndTimeRule: {
        ejsMeetingEndTime: {
          required: true,
          regex: /^([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i,
        },
      },
      resolutionTypeRule: {
        ejsResolutionType: {
          required: [true, this.$t("agenda.msgIsMandatory")],
        },
      },
      locationValidationRules: {
        ejsLocation: {
          required: [true, this.$t("agenda.msgIsMandatory")],
          regex: [this.checkString, this.$t("agenda.msgIsMandatory")],
        },
      },
      timePickerModel: {
        placeholder: this.$t("agenda.lblTimePickerModel"),
        value: new Date(),
      },
      screenHeight: 0,
    };
  },
  async created() {
    await this.getMeetingDocumentViews({
      meeting_id: this.selectedMeetingID,
      user_email: this.$auth.user.email,
    });
    const configList = await tenantConfigService.getTenantConfigList();
    const defaultLineNumConfig = configList.find(config => config.configname === "defaultLineNum");
    this.currentConfig = defaultLineNumConfig || {};
    const configAbstractNumber = Array.isArray(this.currentConfig.defaultLineNum) ? this.currentConfig.defaultLineNum.find((item) => item.item === "Abstract") : null;
    this.abstractRows = configAbstractNumber ? configAbstractNumber.num : 2;
    const configAttendanceNoteNumber = Array.isArray(this.currentConfig.defaultLineNum) ? this.currentConfig.defaultLineNum.find((item) => item.item === "Attendance Note") : null;
    this.attendanceNoteRows = configAttendanceNoteNumber ? configAttendanceNoteNumber.num : 1;
    this.renderRightPanel++;

    this.$eventHub.$on("onExpandCollapseClick", this.expandCollapseLeftPane);
    this.$eventHub.$on("onMeetingUpdate", this.onUpdateMeetingData);
    this.$eventHub.$on("onDeleteDocuments", this.onDeleteDocuments);
    this.$eventHub.$on("onNewAgenda", this.onAddNewAgenda);
    this.$eventHub.$on("saveOnApproval", this.saveOnApproval);
    this.$eventHub.$on("changeVoatingStatus", this.onChangeVoatingStatus);
    this.$eventHub.$on("onInterimPresentorAdd", this.onInterimPresentorAdd);
    this.$eventHub.$on("onGeneralFileUpload", this.onGeneralFileUpload);
    this.$eventHub.$on("onSaveMeeting", this.saveMeeting);
    this.$eventHub.$on("isSilentSignalR", this.isSilentSignalR);
    this.$eventHub.$on("onTopicMovie", () => {
      this.isTopicMovie = true;
      this.isDirty = true;
    });
  },
  async mounted() {
    try {
      this.LoaderText = this.$t("LoaderText");
      this.Loaderloading = true;
      const result = await this.$refs.refSwitchDialog.checkTenantName();
      if (!result) {
        const waitForUserList = async () => {
          return new Promise((resolve) => {
            const checkUserList = () => {
              if (this.userList.length) {
                resolve();
              } else {
                setTimeout(checkUserList, 10);
              }
            };
            checkUserList();
          });
        };
        await waitForUserList();
        this.selectedMeeting = await this.getMeetingDetails(
          this.selectedMeetingID
        );
        this.$set(this.selectedMeeting, "meeting_feedbacks", null);

        this.selectedMeeting.topics = this.selectedMeeting.topics.map(
          (item) => {
            return { ...item, memoDescription: item.memoDescription || "" };
          }
        );

        const target = "meeting_" + this.selectedTenant;
        const targetAgendaTopics = "meeting_agenda_" + this.selectedTenant;
        const tagTarget = `meeting_tags_${this.selectedTenant}`;
        const attendanceTarget = `attendance_${this.selectedMeetingID}`;
        await this.signalRInit(target); // Commented for voting Enhancement issue
        await this.signalUpdateTopics(targetAgendaTopics);
        await this.signalRSaveTag(tagTarget);
        await this.signalRAttendance(attendanceTarget);

        const updteMeetingTimerSignalRTarget =
          "Save_MeetingTimer_" + this.selectedMeetingID;
        await this.updteMeetingTimerSignalR(updteMeetingTimerSignalRTarget);

        const transcriptTarget = "transcript_" + this.selectedMeetingID;
        await this.signalRInitTranscription(transcriptTarget);

        const adminTarget = "admin_" + this.selectedTenant;
        await this.signalRInitAdmin(adminTarget);

        const wansignEmailTarget = "wansign_email_" + this.selectedMeetingID;
        await this.signalRInitWanSignEmail(wansignEmailTarget);
        if (this.selectedMeeting && this.selectedMeeting.mom_signature_data) {
          this.setWanSignEmailStatus(this.selectedMeeting.mom_signature_data);
        } else {
          this.setWanSignEmailStatus(null);
        }

        this.selectedMeeting.description =
          await this.bindMeetingDecriptionImages();

        await this.getTenantConfigList();
        if (!this.selectedMeeting) {
          await this.meetingNotFoundMessage(this.selectedMeetingID);
          this.$router.push({ path: "/" });
        } else {
          this.selectedMeeting.movedTopicList = [];
          if (!this.selectedMeeting.interimPresentorList) {
            this.$set(this.selectedMeeting, "interimPresentorList", []);
          }
          localStorage.setItem(
            this.meetingTypeStorageKey,
            this.selectedMeeting.meetingType
          );
          const filter = {
            is_archived: false,
            meeting_type_id: this.selectedMeeting.meetingTypeId,
          };
          await this.getAgendaListByMeetingType(filter);

          this.setMeetingType(this.selectedMeeting.meetingType);
          await this.getDeletedAttendees(this.selectedMeeting.attendees);
        }
        this.Loaderloading = false;
      }
    } catch (error) {
      this.Loaderloading = false;
    }
  },
  beforeDestroy() {
    this.$eventHub.$off("onExpandCollapseClick");
    this.$eventHub.$off("onMeetingUpdate");
    this.$eventHub.$off("onDeleteDocuments");
    this.$eventHub.$off("onNewAgenda");
    this.$eventHub.$off("saveOnApproval");
    this.$eventHub.$off("changeVoatingStatus");
    this.$eventHub.$off("onInterimPresentorAdd");
    this.$eventHub.$off("onGeneralFileUpload");
    this.$eventHub.$off("onSaveMeeting");
    this.$eventHub.$off("onTopicMovie");
    this.$eventHub.$off("isSilentSignalR");
  },
  components: {
    MessageSheet,
    ConfirmDialog,
    PreventNavigation,
    TenantSwitchDialog,
    EmailUsersList,
    EmailSendConfirmation,
    MeetingNavigation,
    MeetingCard,
    FileInput,
    AgendaMeetingDetailsCard,
    AgendaTableNew,
    MeetingDetailsRightPanelTemplate,
    InPlaceEditorForMeetingName,
    InPlaceTextFieldEditor,
    MeetingEmailNotification,
  },
  provide: {
    inplaceeditor: [Rte, TimePicker, ComboBox],
  },
  props: {
    selectedMeetingID: String,
  },
  watch: {
    isMeetingDataModified(value) {
      this.$eventHub.$emit("meetingDataModified", value);
    },
    locale() {
      this.hideSHow = false;
      setTimeout(() => {
        this.hideSHow = true;
      }, 1);
    },
    selectedMeeting() {
      this.updatedMeetingObj = Object.assign({}, this.selectedMeeting);
      this.meetingKey = this.updateMeetingData.id;
      this.deleteDocumentIds = [];
    },
    async topicFeedbackPermission(value) {
      if (value) {
        const feedbacks = await this.getMeetingFeedbacks(
          this.selectedMeetingID
        );
        this.$set(this.selectedMeeting, "meeting_feedbacks", feedbacks || []);
      }
    },
  },
  computed: {
    isMeetingSaveButtonEnabled() {
      return (
        !this.isMeetingDataModified &&
        !this.isDescriptionWithImg &&
        !this.isTopicMovie
      );
    },
    shouldPreventNavigation() {
      return this.isDescriptionWithImg
        ? false
        : this.isDirty && this.updateMeetingPermission;
    },
    pageContentStyle() {
      if (this.padding) {
        return {
          paddingTop: `${this.padding}px`,
        };
      }
    },
    comboBoxModel() {
      return {
        dataSource: ["In Writing", "Remote", "Hybrid", "In Person"],
        placeholder: this.$t("agenda.lblComboBoxModel"),
      };
    },
    textModel() {
      return {
        placeholder: this.$t("agenda.lblTextModel"),
      };
    },
    themeModel() {
      return {
        placeholder: this.$t("agenda.lblThemeModel"),
      };
    },
    locationModel() {
      return {
        placeholder: this.$t("agenda.lblLocationModel"),
      };
    },
    dateTimePickerModel() {
      return {
        placeholder: this.$t("agenda.lblDateTimePickerModel"),
      };
    },
    locale() {
      return this.$i18n.locale;
    },
    dateFormat() {
      return this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm";
    },
    startDateTimePickerModel() {
      return {
        placeholder: this.$t("agenda.lblDateTimePickerModel"),
        format:
          this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm",
        enableMask: true,
        strictMode: true,
        step: "15",
        width: 180,
      };
    },
    endDateTimePickerModel() {
      return {
        placeholder: this.$t("agenda.lblDateTimePickerModel"),
        format:
          this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm",
        enableMask: "true",
        strictMode: "true",
        step: "15",
        min: this.minEndDate,
        width: 180,
      };
    },
    minEndDate() {
      return this.roundTimeQuarterHour(
        new Date(this.meetingObject.scheduletStartTimeInUTC)
      );
    },
    dateTimePickerModel() {
      return {
        placeholder: this.$t("agenda.lblDateTimePickerModel"),
        format:
          this.locale !== "ja" ? "dd-MM-yyyy hh:mm a" : "yyyy-MM-dd HH:mm",
        enableMask: "true",
        strictMode: "true",
        step: "15",
      };
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    ...mapState({
      agendaSelectedTab: (state) => state.agenda.agendaSelectedTab,
      meetingListData: (state) => state.meeting.meetingListByType,
      agendaListByMeetingType: (state) => state.agenda.agendaListByMeetingType,
      userList: (state) => state.people.userList,
    }),
    refreshTime() {
      if (this.updateMeetingPermission || this.createMeetingPermission) {
        return 5000;
      }
      return 5000;
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    meetingTypeStorageKey() {
      return "meetingType#" + this.selectedTenant;
    },
    scrollbarTheme() {
      return this.$vuetify.theme.dark ? "dark" : "dark";
    },
    topicHeaders() {
      return [
        {
          text: "Agenda",
          align: "start",
          value: "agendaTitle",
          class: "appBar",
        },
        {
          align: "start",
          text: "Topic",
          value: "topicName",
          class: "appBar",
        },
        {
          align: "start",
          text: "Documents",
          value: "documents",
          class: "appBar",
          sortable: false,
        },
        {
          align: "start",
          text: "PIC",
          value: "picName",
          class: "appBar",
        },
        {
          align: "start",
          text: "Time",
          value: "timeInMinutes",
          class: "appBar",
          sortable: false,
        },
        {
          align: "start",
          text: "Actual Time",
          value: "actualTime",
          class: "appBar",
          sortable: false,
        },
      ];
    },
    localUserList() {
      return this.userList ? this.userList.concat(this.deleteUsers) : [];
    },
    meetingObject() {
      let meetingObj = {
        id: "",
        tenantid: this.selectedTenant,
        meetingName: "",
        meetingType: "",
        resolutionType: "",
        meetingTheme: "",
        scheduletStartTimeInUTC: null,
        scheduledEndTimeInUTC: null,
        actualStartTimeInUTC: null,
        actualEndTimeInUTC: null,
        description: "",
        location: "",
        topics: [],
        documents: null,
        attendees: [],
        movedTopicList: [],
        interimPresentorList: [],
        description_meta: [],
        meeting_feedbacks: [],
      };
      if (this.selectedMeeting) {
        if (
          this.selectedMeeting.attendees &&
          this.selectedMeeting.attendees.length > 0
        ) {
          this.selectedMeeting.attendees = this.selectedMeeting.attendees.map(
            (item) => {
              const uData =
                this.localUserList.find((u) => u.id === item.id) || {};
              const contactEmailIds =
                uData.contactEmailIds?.filter(
                  (email) => email !== item.email
                ) || [];
              return {
                ...item,
                profilePhoto: uData.profilePhoto || null,
                title: item.title || (uData.title || ""),
                firstName: item.firstName || (uData.firstName || ""),
                lastName: item.lastName || (uData.lastName || ""),
                contactEmailIds:
                  item.contactEmailIds?.length > 0
                    ? item.contactEmailIds
                    : contactEmailIds,
              };
            }
          );
        }
        return this.selectedMeeting;
      } else {
        return meetingObj;
      }
    },
    meetingStartTime() {
      return (
        this.selectedMeeting.meetingdate + " " + this.selectedMeeting.starttime
      );
    },
    navigation() {
      return this.meetingNavigation;
    },
    meetingTypeId() {
      if (this.selectedMeeting) {
        return this.selectedMeeting.meetingTypeId;
      }
      return null;
    },
    updateMeetingPermission() {
      if (this.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingTypeId,
          "UpdateMeeting"
        );
      }
      return false;
    },
    createMeetingPermission() {
      if (this.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingTypeId,
          "CreateMeeting"
        );
      }
      return false;
    },
    viewMeetingPermission() {
      if (this.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingTypeId,
          "ViewMeeting"
        );
      }
      return false;
    },
    isMeetingTimeValid() {
      if (
        this.selectedMeeting &&
        this.selectedMeeting.scheduletStartTimeInUTC &&
        this.selectedMeeting.scheduledEndTimeInUTC
      ) {
        const startDate = new Date(
          this.selectedMeeting.scheduletStartTimeInUTC
        );
        const endDate = new Date(this.selectedMeeting.scheduledEndTimeInUTC);
        return endDate > startDate;
      }
      return true;
    },
    isParticipants() {
      if (this.meetingObject.attendees.length == 0) return false;
      const attendees = this.meetingObject.attendees.flatMap((item) => {
        const mainAttendee = { ...item, email: item.email };
        const additionalAttendees = (item.contactEmailIds || [])
          .filter((email) => email)
          .map((email) => ({ ...item, email }));

        return [mainAttendee, ...additionalAttendees];
      });
      return attendees.some(
        (item) =>
          item.email === this.$auth.user.email && item.attendedState === null
      );
    },
    isMeetingRecurrence() {
      if (this.meetingObject.recurrenceData) {
        return this.meetingObject.recurrenceData.isMeetingRecurrence;
      }
      return false;
    },
    topicFeedbackPermission() {
      if (this.meetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.meetingTypeId,
          "CreateTopicFB"
        );
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      updateMeetingData: "meeting/updateAgendaMeeting",
      createAgendaData: "agenda/createAgenda",
      getMeetingDetails: "meeting/getMeetingById",
      getMeetingByIdForSignalR: "meeting/getMeetingByIdForSignalR",
      deleteDocuments: "document/deleteDocuments",
      createDocuments: "document/createDocuments",
      getTenantConfigList: "tenant/getTenantConfigList",
      getMeetingDocumentViews: "document/getMeetingDocumentViews",
      setMeetingType: "meeting/setMeetingType",
      getMeetingListApi: "meeting/getMeetingList",
      getAgendaById: "agenda/getAgendaById",
      getAgendaListByMeetingType: "agenda/getAgendaListByMeetingType",
      getDeletedUsersList: "meeting/getDeletedUsersListTemp",
      setTranscriptionStatus: "meeting/setTranscriptionStatus",
      setWanSignEmailStatus: "meeting/setWanSignEmailStatus",
      downloadDocumentAPI: "document/downloadDocument",
      getMeetingFeedbacks: "meeting/getMeetingFeedbacks",
      setVotingData: "meeting/setVotingData",
    }),
    currentDateTime,
    goToAtttendance() {
      const element = document.getElementById("attendanceList");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    },
    otherInfoDescription(data) {
      this.isDescriptionWithImg = data;
    },
    onPanelClick(e) {
      if (e?.target?.classList.contains("v-expansion-panel-header--active")) {
        this.basicInfoPanel = false;
      } else {
        this.basicInfoPanel = true;
      }
    },
    async getDeletedAttendees(attendees) {
      const userWithIdExists = (id) =>
        this.userList.some((obj) => obj.id === id);
      const unmatchedObjects = attendees.filter(
        (obj) => !userWithIdExists(obj.id)
      );
      const unmatchedIds = unmatchedObjects.map((obj) => obj.id);
      if (unmatchedIds.length) {
        const result = await this.getDeletedUsersList(unmatchedIds);
        if (result.length) {
          this.deleteUsers = result;
        }
      }
    },
    onStartDateChange,
    roundTimeQuarterHour,
    onEndDateChange,
    closeMessageSheet() {
      this.displayMessage = false;
      this.hideMeetingNavigationTip();
    },
    hideMeetingNavigationTip() {
      this.prevTooltip = true;
      this.nextTooltip = true;
      setTimeout(() => {
        this.prevTooltip = false;
        this.nextTooltip = false;
      }, 500);
    },
    checkString(args) {
      return args.value === null || args.value.match(/^ *$/) === null;
    },
    checkFormValid(meetingObj) {
      if (
        String(meetingObj.meetingName).trim() === "" ||
        String(meetingObj.scheduletStartTimeInUTC).trim() === "" ||
        meetingObj.scheduletStartTimeInUTC === null ||
        String(meetingObj.scheduledEndTimeInUTC).trim() === "" ||
        meetingObj.scheduledEndTimeInUTC === null ||
        String(meetingObj.resolutionType).trim() === "" ||
        meetingObj.resolutionType === null ||
        String(meetingObj.location).trim() === "" ||
        meetingObj.resolutionType === null ||
        !this.isMeetingTimeValid
      ) {
        this.isMeetingDataModified = false;
      } else if (meetingObj.meetingTheme && meetingObj.meetingTheme === "") {
        this.isMeetingDataModified = false;
      } else if (
        meetingObj.meeting_link &&
        !isURL(
          meetingObj.meeting_link ? String(meetingObj.meeting_link).trim() : ""
        )
      ) {
        this.isMeetingDataModified = false;
      }
    },
    meetingNameStyle(value) {
      setTimeout(() => {
        if (value && value >= 65) {
          this.padding = value - 40;
        } else if (value) {
          this.padding = 3;
        } else {
          this.padding = 20;
        }
      }, 100);
    },

    cancel(event) {
      this.hideMeetingNavigationTip();
      localStorage.setItem(
        this.meetingTypeStorageKey,
        this.selectedMeeting.meetingType
      );
      this.setMeetingType(this.selectedMeeting.meetingType);
      //event.next(false);
      return false;
    },
    compareDate(args) {
      const endDateValue = args.value;
      const start_date = new Date(
        this.$refs.ejsStartDateTimeObj.ej2Instances.value
      );
      const end_date = new Date(endDateValue);
      if (end_date.getTime() <= start_date.getTime()) {
        return false;
      }
      return true;
    },
    startDatechangeEjs(args) {
      if (
        (args.value && String(args.value).trim() == "") ||
        args.value == null
      ) {
        this.isMeetingDataModified = false;
      } else {
        this.isMeetingDataModified = true;
        this.onStartDateChange(args);
      }
    },
    endDatechangeEjs(args) {
      if (
        (args.value && String(args.value).trim() == "") ||
        args.value == null
      ) {
        this.isMeetingDataModified = false;
      } else {
        this.isMeetingDataModified = true;
        this.onEndDateChange(args);
      }
    },
    changeEjs(args) {
      if (
        (args.value && String(args.value).trim() == "") ||
        args.value == null
      ) {
        this.isMeetingDataModified = false;
      } else {
        this.isMeetingDataModified = true;
      }
    },
    async signalRSaveTag(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          let updatedMeeting = res.meeting_id;
          if (updatedMeeting === this.selectedMeeting.id) {
            this.selectedMeeting.topics.forEach((topic) => {
              if (topic.Id === res.topic_id) {
                topic.tags = res.tags;
                this.$root.$emit("refresh-tag", topic);
              }
            });
          }
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {}
    },
    async signalRInit(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          if (!res.hasOwnProperty("deleted")) {
            let updatedMeetingList = [res.meeting_id];
            if (res.target_meeting_id) {
              updatedMeetingList = updatedMeetingList.concat(
                res.target_meeting_id
              );
            }
            updatedMeetingList.forEach(async (meeting_id) => {
              if (meeting_id === this.selectedMeetingID) {
                let paylod = this.selectedMeetingID
               if(this.isSilentRequest){
                paylod = {id: this.selectedMeetingID, isSilentRequest: this.isSilentRequest}
               }
                const meeting = await this.getMeetingDetails(paylod);
                if (meeting) {
                  const feedbacks = this.topicFeedbackPermission
                    ? await this.getMeetingFeedbacks(paylod)
                    : [];
                  this.getDeletedAttendees(meeting.attendees);
                  meeting.movedTopicList = [];
                  ["interimPresentorList", "description_meta"].forEach(
                    (key) => {
                      meeting[key] = meeting[key] || [];
                    }
                  );
                  this.selectedMeeting = meeting;
                  this.$set(
                    this.selectedMeeting,
                    "meeting_feedbacks",
                    feedbacks
                  );
                  this.selectedMeeting.description =
                    await this.bindMeetingDecriptionImages();
                  this.$root.$emit("refresh-meeting", this.selectedMeeting);
                  this.$root.$emit(
                    "refresh-meeting-left",
                    this.selectedMeeting
                  );
                  if (
                    this.updateMeetingPermission ||
                    this.createMeetingPermission
                  ) {
                    this.isMeetingDataModified = false;
                    if (
                      String(res.user_email).toLowerCase() !==
                      String(this.$auth.user.email).toLowerCase()
                    ) {
                      let adminName = res.user_name;
                      if (!adminName || adminName === "") {
                        adminName = res.user_email;
                      }
                      this.showMessageSheet(
                        this.$t("agenda.MeetingUpdateNotice", {
                          adminUser: adminName,
                        }),
                        "info"
                      );
                      this.$root.$emit("manage-agenda-dialog", false);
                    }
                    this.skipUpdateMessage = false;
                  }
                  if (meeting.topics) {
                    this.setVotingData(meeting.topics);
                  }
                } else {
                  await this.$refs.confirm.open(
                    this.$t("agenda.hdDeleteWarning"),
                    this.$t("agenda.msgMeetingDeleteTxt"),
                    {
                      removeAgreeBtn: true,
                      btnCancel: this.$t("btnOk"),
                    }
                  );
                  this.$router.push({ path: "/" });
                }
              }
            });
          } else {
            if (
              res.deleted &&
              res.meeting_ids.includes(this.selectedMeetingID)
            ) {
              this.isDirty = false;
              await this.$refs.confirm.open(
                this.$t("agenda.hdDeleteWarning"),
                this.$t("agenda.msgMeetingDeleteTxt"),
                {
                  removeAgreeBtn: true,
                  btnCancel: this.$t("btnOk"),
                }
              );
              this.$router.push({ path: "/" });
            }
          }
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async updteMeetingTimerSignalR(target) {
      this.signalConnection.on(target, async (res) => {
        if (res.meeting_id === this.selectedMeetingID) {
          const meeting = await this.getMeetingDetails(this.selectedMeetingID);
          if (meeting) {
            this.getDeletedAttendees(meeting.attendees);
            meeting.movedTopicList = [];
            if (!meeting.interimPresentorList) {
              meeting.interimPresentorList = [];
            }
            if (!meeting.meeting_feedbacks) {
              meeting.meeting_feedbacks = [];
            }

            this.selectedMeeting.startMeetingTime = meeting.startMeetingTime;
            this.selectedMeeting.endMeetingTime = meeting.endMeetingTime;

            this.$root.$emit("refresh-meeting", this.selectedMeeting);
            this.$root.$emit("refresh-meeting-left", this.selectedMeeting);
            if (this.updateMeetingPermission || this.createMeetingPermission) {
              this.isMeetingDataModified = false;
              if (
                String(res.user_email).toLowerCase() !==
                String(this.$auth.user.email).toLowerCase()
              ) {
                let adminName = res.user_name;
                if (!adminName || adminName === "") {
                  adminName = res.user_email;
                }
                this.showMessageSheet(
                  this.$t("agenda.MeetingUpdateNotice", {
                    adminUser: adminName,
                  }),
                  "info"
                );
                this.$root.$emit("manage-agenda-dialog", false);
              }
              this.skipUpdateMessage = false;
            }
          } else {
            await this.$refs.confirm.open(
              this.$t("agenda.hdDeleteWarning"),
              this.$t("agenda.msgMeetingDeleteTxt"),
              { dialogIcon: "alert" }
            );
            this.$router.push({ path: "/" });
          }
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
    async signalRInitTranscription(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          this.Loaderloading = true;
          this.setTranscriptionStatus({
            document: res.document,
            status: res.status,
            transcript_error_message:
              res.transcript_error_message ?? "msgTranscriptionQueueStatus",
          });
          this.Loaderloading = false;
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    async signalRInitWanSignEmail(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          this.setWanSignEmailStatus({
            wansign_transaction_id: res.wansign_transaction_id,
            wansign_control_number: res.wansign_control_number,
            document_name: res.document_name,
          });
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    async signalRInitAdmin(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          const meeting = await this.getMeetingByIdForSignalR(
            this.selectedMeetingID
          );
          if (meeting) {
            this.selectedMeeting.attendees = this.selectedMeeting.attendees.map(
              (attendee) => {
                const resData = meeting.attendees.find(
                  (item) => item.id === attendee.id
                );
                return resData ? resData : attendee;
              }
            );
            if (meeting.topics) {
              this.setVotingData(meeting.topics);
            }
          }
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    async signalRAttendance(target) {
      try {
        this.signalConnection.on(target, async (res) => {
          this.selectedMeeting.attendees = this.selectedMeeting.attendees.map(
            (attendee) => {
              const resData = res.attendees.find(
                (item) => item.id === attendee.id
              );
              return {
                ...attendee,
                attendedState: resData?.attendedState ?? null,
              };
            }
          );
        });
        if (
          this.signalConnection.connectionState.toLowerCase() === "disconnected"
        ) {
          this.signalConnection.start().catch();
        }
      } catch (error) {
        this.Loaderloading = false;
      }
    },
    async signalUpdateTopics(target) {
      this.signalConnection.on(target, async (message) => {
        const { updated_meetings } = message;
        const filter = {
          is_archived: false,
          meeting_type_id: this.selectedMeeting.meetingTypeId,
        };
        this.getAgendaListByMeetingType(filter);
        this.getAgendaListByMeetingType({
          is_archived: true,
          meeting_type_id: this.selectedMeeting.meetingTypeId,
        });
        if (message.action === "update") {
          const isMeetingUpdated = updated_meetings.includes(
            this.selectedMeetingID
          );
          if (isMeetingUpdated) {
            const agendaDetails = await this.getAgendaById(message.agenda_id);
            if (agendaDetails) {
              const topics = cloneDeep(agendaDetails.topics);
              topics.forEach((topic) => {
                let findTopic = this.selectedMeeting.topics.find(
                  (t) => t.Id === topic.Id && t.agendaId === message.agenda_id
                );
                if (findTopic) {
                  findTopic.topicName = topic.topicName;
                  findTopic.timeInMinutes = topic.timeInMinutes;
                  findTopic.topicCategory = topic.topicCategory;
                }
              });
              for (var i = 0; i < this.selectedMeeting.topics.length; i++) {
                var obj = this.selectedMeeting.topics[i];
                if (
                  obj.agendaId === message.agenda_id &&
                  !topics.some((t) => t.Id === obj.Id)
                ) {
                  this.selectedMeeting.topics.splice(i, 1);
                  i--;
                }
              }
            } else {
              await this.$refs.confirm.open(
                this.$t("agenda.hdDeleteWarning"),
                this.$t("agenda.msgMeetingDeleteTxt"),
                { dialogIcon: "alert" }
              );
              this.$router.push({ path: "/" });
            }
          }
        }
        if (message.action === "delete") {
          this.selectedMeeting.topics = this.selectedMeeting.topics.filter(
            (f) => f.agendaId != message.agenda_id
          );
        }
      });
      if (
        this.signalConnection.connectionState.toLowerCase() === "disconnected"
      ) {
        this.signalConnection.start().catch();
      }
    },
    saveOnLeave({ to, next }) {
      this.nextRoute = to ? to : null;
      if (this.generalDocuments.length && this.isGeneralDocsValid) {
        this.handleGeneralFileUpload();
      }
      this.hideMeetingNavigationTip();
      this.emailNotificationRequired = true;
      this.updateMeeting().then((res) => {
        // next();
      });
    },
    async saveMeeting() {
      if (this.generalDocuments.length && this.isGeneralDocsValid) {
        this.handleGeneralFileUpload();
      }
      this.emailNotificationRequired = true;
      await this.updateMeeting();
      this.skipUpdateMessage = true;
    },
    handleGeneralFileUpload() {
      let arr = this.selectedMeeting.generalMeetingDocs || [];
      for (const item of this.generalDocuments) {
        const isChunkUpload = this.chunkUploadFilesList.some(
          (c) => c.fileName === item.name && c.isChunkUpload === true
        );
        let documentId = createUUID();
        const formData = new FormData();
        formData.append("tenantId", this.selectedTenant);
        formData.append("topicId", "");
        formData.append("documentId", documentId);
        formData.append("meetingId", this.selectedMeeting.id);
        formData.append("agendaId", "");
        formData.append("directoryId", "");
        formData.append("peopleId", "");
        formData.append("file", item);
        formData.append("chunk_upload", isChunkUpload);
        formData.append("filename", item.name);
        formData.append("content_type", item.type);
        formData.append("document_type", "general_document");

        let obj = {
          agendaid: "",
          directoryid: "",
          documentId: documentId,
          fileName: item.name,
          lastModified: currentDateTime(item.lastModified),
          meetingid: this.selectedMeeting.id,
          mimetype: item.type,
          peopleid: "",
          size: item.size,
          tenantid: "",
          topicId: this.selectedTenant,
          formData: formData,
          item: item,
          isChunkUpload: isChunkUpload,
          document_type: "general_document",
        };
        arr.push(obj);
        this.meetingObject.generalMeetingDocs = arr;
      }
    },
    onGeneralFileUpload(generalDocuments, isFilesValid, chunkUploadFilesList) {
      this.isGeneralDocsValid = isFilesValid;
      this.generalDocuments = generalDocuments;
      this.chunkUploadFilesList = chunkUploadFilesList;
      if (!generalDocuments.length || !isFilesValid) {
        this.isMeetingDataModified = false;
        return;
      }
    },
    async updateMeeting() {
      const attendees = this.selectedMeeting.attendees.map((item) => {
        const itemObj = {
          id: item.id,
          email: item.email,
          attendedState: item.attendedState,
          is_authorized: item.is_authorized,
        };

        if (item.emailList && item.emailList.length > 0) {
          itemObj.emailList = item.emailList;
        }

        if (item.contactEmailIds) {
          itemObj.contactEmailIds = item.contactEmailIds;
        }
        // Assign user details only if guest or valid first & last name exist
        if (item.isGuest && (item.firstName && item.lastName)) {
          itemObj.firstName = item.firstName;
          itemObj.lastName = item.lastName;
          itemObj.title = item.title;
          itemObj.isGuest = item.isGuest;
        }
        if (item.attendeNote !== undefined && item.attendeNote !== null) {
          itemObj.attendeNote = item.attendeNote;
        }

        return itemObj;
      });

      if (this.isMeetingDataModified || this.isTopicMovie) {
        this.LoaderText = this.$t("SaveLoader");
        this.Loaderloading = true;
        try {
          this.newAgendaObjList.forEach(async (newAgendaObj) => {
            const topics = [];
            newAgendaObj.topics.forEach((topic) => {
              topic.documents = [];
              topics.push(topic);
            });
            if (newAgendaObj.id) {
              newAgendaObj.topics = topics;
              await this.createAgendaData(newAgendaObj);
            }
          });

          this.newAgendaObjList = [];
          this.updatedMeetingObj = await this.getMeetingDetails(
            this.selectedMeeting.id
          );
          this.updatedMeetingObj.movedTopicList = [];

          ["interimPresentorList", "description_meta"].forEach((key) => {
            if (!this.updatedMeetingObj[key]) {
              this.updatedMeetingObj[key] = [];
            }
          });

          if (
            JSON.stringify(this.updatedMeetingObj.generalMeetingDocs) ===
              JSON.stringify(this.selectedMeeting.generalMeetingDocs) &&
            JSON.stringify(this.updatedMeetingObj.topics) ===
              JSON.stringify(this.selectedMeeting.topics) &&
            JSON.stringify(this.updatedMeetingObj.attendees) ===
              JSON.stringify(attendees) &&
            this.updatedMeetingObj.description ===
              this.selectedMeeting.description &&
            JSON.stringify(this.updatedMeetingObj.momDocuments) ===
              JSON.stringify(this.selectedMeeting.momDocuments) &&
            JSON.stringify(this.updatedMeetingObj.location) ===
              JSON.stringify(this.selectedMeeting.location) &&
            JSON.stringify(this.updatedMeetingObj.resolutionType) ===
              JSON.stringify(this.selectedMeeting.resolutionType) &&
            JSON.stringify(this.updatedMeetingObj.meetingTheme) ===
              JSON.stringify(this.selectedMeeting.meetingTheme) &&
            JSON.stringify(this.updatedMeetingObj.scheduletStartTimeInUTC) ===
              JSON.stringify(this.selectedMeeting.scheduletStartTimeInUTC) &&
            JSON.stringify(this.updatedMeetingObj.scheduledEndTimeInUTC) ===
              JSON.stringify(this.selectedMeeting.scheduledEndTimeInUTC) &&
            JSON.stringify(this.updatedMeetingObj.startMeetingTime) ===
              JSON.stringify(this.selectedMeeting.startMeetingTime) &&
            JSON.stringify(this.updatedMeetingObj.endMeetingTime) ===
              JSON.stringify(this.selectedMeeting.endMeetingTime) &&
            JSON.stringify(this.updatedMeetingObj.meetingName) ===
              JSON.stringify(this.selectedMeeting.meetingName) &&
            JSON.stringify(this.updatedMeetingObj.topicCategories) ===
              JSON.stringify(this.selectedMeeting.topicCategories) &&
            JSON.stringify(this.updatedMeetingObj.movedTopicList) ===
              JSON.stringify(this.selectedMeeting.movedTopicList) &&
            JSON.stringify(this.updatedMeetingObj.meeting_link) ===
              JSON.stringify(this.selectedMeeting.meeting_link) &&
            JSON.stringify(this.updatedMeetingObj.interimPresentorList) ===
              JSON.stringify(this.selectedMeeting.interimPresentorList) &&
            JSON.stringify(this.updatedMeetingObj.description_meta) ===
              JSON.stringify(this.selectedMeeting.description_meta)
            // && JSON.stringify(this.updatedMeetingObj.meeting_feedbacks) ===
            //   JSON.stringify(this.selectedMeeting.meeting_feedbacks)
          ) {
            this.showMessageSheet(this.$t("InfoNoChange"), "info");
            this.isMeetingDataModified = false;
            this.isDirty = false;
            this.Loaderloading = false;
            return;
          }
          await this.uploadMeetingDescriptionImages();
          await this.documentsActions();
          await this.handleTopicChanges();

          this.updatedMeetingObj.generalMeetingDocs =
            this.selectedMeeting.generalMeetingDocs;
          this.updatedMeetingObj.topicCategories =
            this.selectedMeeting.topicCategories;
          this.updatedMeetingObj.attendees = attendees;
          this.updatedMeetingObj.topics = this.selectedMeeting.topics;
          this.updatedMeetingObj.description = this.selectedMeeting.description;
          this.updatedMeetingObj.momDocuments =
            this.selectedMeeting.momDocuments;
          this.updatedMeetingObj.location = this.selectedMeeting.location;
          this.updatedMeetingObj.resolutionType =
            this.selectedMeeting.resolutionType;
          this.updatedMeetingObj.meetingTheme =
            this.selectedMeeting.meetingTheme;
          this.updatedMeetingObj.meeting_link =
            this.selectedMeeting.meeting_link;
          this.updatedMeetingObj.scheduletStartTimeInUTC = new Date(
            this.selectedMeeting.scheduletStartTimeInUTC
          ).toISOString();
          this.updatedMeetingObj.scheduledEndTimeInUTC = new Date(
            this.selectedMeeting.scheduledEndTimeInUTC
          ).toISOString();
          // this.updatedMeetingObj.startMeetingTime =
          //   this.selectedMeeting.startMeetingTime;
          this.updatedMeetingObj.endMeetingTime =
            this.selectedMeeting.endMeetingTime;
          this.updatedMeetingObj.meetingName = this.selectedMeeting.meetingName;
          this.updatedMeetingObj.movedTopicList =
            this.selectedMeeting.movedTopicList;
          this.updatedMeetingObj.interimPresentorList =
            this.selectedMeeting.interimPresentorList;
          // this.updatedMeetingObj.meeting_feedbacks =
          //   this.selectedMeeting.meeting_feedbacks;

          // this.updatedMeetingObj.description_meta =
          //   this.selectedMeeting.description_meta;

          let update_description_meta =
            this.selectedMeeting.description_meta.map(
              ({ encoded_image, ...rest }) => rest
            );
          this.updatedMeetingObj.description_meta = [
            ...update_description_meta,
          ];
          await this.updateMeetingData(this.updatedMeetingObj).then(
            async (response) => {
              this.Loaderloading = false;
              this.skipUpdateMessage = true;

              if (this.updatedMeetingObj.meetingName.length > 100) {
                this.updatedMeetingObj.meetingName =
                  this.updatedMeetingObj.meetingName.slice(0, 100) + "...";
              }

              const delDocs =
                response.removed_docs && response.removed_docs.length > 0
                  ? response.removed_docs
                      .map(function (val, index) {
                        return (index + 1).toString() + ". " + val;
                      })
                      .join(", ")
                  : "";

              this.isMeetingUpdatMsgDeletedDoc =
                response.removed_docs && response.removed_docs.length > 0
                  ? true
                  : false;
              const meetingSuccessMsg =
                response.removed_docs && response.removed_docs.length > 0
                  ? this.$t("agenda.MeetingUpdated", {
                      meetingName: this.updatedMeetingObj.meetingName,
                    }) +
                    "<br>" +
                    this.$t("agenda.MeetingUpdatedDeletedDocMsg", {
                      documents: delDocs,
                    })
                  : this.$t("agenda.MeetingUpdated", {
                      meetingName: this.updatedMeetingObj.meetingName,
                    });

              this.showMessageSheet(meetingSuccessMsg, "success");
              if (
                this.emailNotificationRequired &&
                this.updatedMeetingObj.attendees.length > 0
              ) {
                let clonedMeetingObject = { ...this.updatedMeetingObj };
                const attendees = await this.processAttendees(
                  this.selectedMeeting.attendees
                );
                clonedMeetingObject.attendees = attendees;
                this.showEmailDialog = true;
                // await this.mailSendConfirmation(
                //   clonedMeetingObject,
                //   "SaveMeetingDetails",
                //   this.$t("agenda.MeetingUpdated", {
                //     meetingName: clonedMeetingObject.meetingName,
                //   })
                // );
              } else {
                if (this.nextRoute && this.nextRoute.path) {
                  setTimeout(() => {
                    this.$router.push({ path: this.nextRoute.path });
                  }, 500);
                }
              }
              this.isMeetingDataModified = false;
              this.isDirty = false;
              this.emailNotificationRequired = false;
              this.meetingKey = "";
              this.isTopicMovie = false;
              //this.$router.go(this.$router.currentRoute)
            }
          );
          if (this.viewMeetingPermission) {
            await this.getMeetingDocumentViews({
              meeting_id: this.selectedMeetingID,
              user_email: this.$auth.user.email,
            });
          }
        } catch (error) {
          this.Loaderloading = false;
          const { status, error_message, error_data } = error.response.data;
          if (status === "failed" && error_message === "movetopic") {
            this.revertMoveTopic();
            await this.topicMoveValidationMessage(error_data);
          } else {
            this.showMessageSheet(
              this.$t("agenda.MeetingUpdateFailed"),
              "error"
            );
          }
        }
      } else {
        this.nextRoute = null;
      }
    },
    async topicMoveValidationMessage(errorData) {
      this.showMessageSheet(
        this.$t("agenda.moveTopicValidationMessage", {
          topicName: errorData.topic_name,
          meetingTitle: errorData.meeting_title,
        }),
        "info"
      );
    },
    revertMoveTopic() {
      // Flatten all topics from the movedTopicList into a single array
      const movedTopics = this.selectedMeeting.movedTopicList.flatMap(
        (moveTopic) => moveTopic.topics
      );

      // Merge the flattened topics into the main topics list
      this.selectedMeeting.topics = [
        ...this.selectedMeeting.topics,
        ...movedTopics,
      ];

      // Clear the movedTopicList
      this.selectedMeeting.movedTopicList = [];
    },
    async processAttendees(attendees) {
      let localUserList = [...this.userList];
      const userWithIdExists = (id) =>
        localUserList.some((obj) => obj.id === id);
      const unmatchedObjects = attendees.filter(
        (obj) => !userWithIdExists(obj.id)
      );
      const unmatchedIds = unmatchedObjects.map((obj) => obj.id);

      if (unmatchedIds.length) {
        const result = await this.getDeletedUsersList(unmatchedIds);
        if (result.length) {
          localUserList = localUserList.concat(result);
        }
      }

      return attendees.map((item) => {
        const uData = localUserList.find((u) => u.id == item.id);
        const contactEmailIds =
          uData && uData.contactEmailIds
            ? uData.contactEmailIds.filter((email) => email !== item.email)
            : [];
        return {
          ...item,
          title: item.title ? item.title : (uData.title || ""),
          firstName: item.firstName ? item.firstName : (uData.firstName || ""),
          lastName: item.lastName ? item.lastName : (uData.lastName || ""),
          profilePhoto: uData ? uData.profilePhoto : "",
          contactEmailIds:
            contactEmailIds.length > 0 ? contactEmailIds : item.contactEmailIds,
        };
      });
    },
    async mailSendConfirmation(meeting, type, notificationMessage) {
      this.emailData = {
        open: true,
        type,
        meetingDetails: meeting,
        newDocuments: this.newDocuments,
        isPersonalised: true,
      };
      this.notificationMessage = notificationMessage;
    },
    onEmailDialogCancel() {
      this.Loaderloading = false;
      this.newDocuments = [];
      this.emailData = {};

      if (this.nextRoute && this.nextRoute.path) {
        this.$router.push({ path: this.nextRoute.path });
      }
    },
    onEmailSend(isSucess) {
      this.Loaderloading = false;
      this.newDocuments = [];
      this.emailData = {};

      if (isSucess) {
        this.showMessageSheet(
          this.$t("agenda.SendEmailNotification"),
          "success"
        );
        if (this.nextRoute && this.nextRoute.path) {
          setTimeout(() => {
            this.$router.push({ path: this.nextRoute.path });
          }, 1000);
        }
      } else {
        this.showMessageSheet(
          this.$t("agenda.FaildEmailNotification"),
          "error"
        );
      }
    },
    onClose() {
      if (this.nextRoute && this.nextRoute.path) {
        setTimeout(() => {
          this.$router.push({ path: this.nextRoute.path });
        }, 1000);
      }
    },
    async handleTopicChanges() {
      this.selectedMeeting.topics.forEach((topic) => {
        let oldTopic = this.updatedMeetingObj.topics.find(
          (s) => s.Id === topic.Id
        );
        if (oldTopic) {
          topic.endtime = oldTopic.endtime ? oldTopic.endtime : null;
          topic.starttime = oldTopic.starttime ? oldTopic.starttime : null;
          topic.timerValue = oldTopic.timerValue ? oldTopic.timerValue : 0;
          topic.timeCounter = oldTopic.timeCounter ? oldTopic.timeCounter : 0;
          topic.elapsed = oldTopic.elapsed ? oldTopic.elapsed : 0;
          topic.status = oldTopic.status ? oldTopic.status : "";
        }
      });
    },
    async documentsActions() {
      this.newDocuments = [];
      this.newDocumentsIds = [];
      if (this.deleteDocumentIds.length) {
        const promises = [];
        this.deleteDocumentIds.forEach((id) => {
          promises.push(this.deleteDocuments(id));
        });
        await Promise.all(promises);
        this.deleteDocumentIds = [];
      }
      this.selectedMeeting.topics;
      const addPromises = [];

      this.selectedMeeting.topics.forEach((topic) => {
        if (topic.documents && topic.documents.length) {
          const documents = topic.documents.filter((f) => f.action === "add");
          documents.forEach((documentObj) => {
            const { formData, action, documentId, ...document } = documentObj;
            addPromises.push(this.createDocuments(formData));
            this.newDocumentsIds.push(documentId);
            const docLink = `${window.location.origin}/download/${documentObj.documentId}/tenant/${this.selectedTenant}`;
            this.newDocuments.push({
              link: docLink,
              name: documentObj.fileName,
            });
          });
          topic.documents = topic.documents.map(
            ({ formData, action, ...rest }) => rest
          );
        }
      });

      if (this.selectedMeeting.momDocuments) {
        const momDocuments = this.selectedMeeting.momDocuments.filter(
          (f) => f.action === "add"
        );
        momDocuments.forEach((documentObj) => {
          const { formData, action, documentId, ...document } = documentObj;
          addPromises.push(this.createDocuments(formData));
          this.newDocumentsIds.push(documentId);
          const docLink = `${window.location.origin}/download/${documentObj.documentId}/tenant/${this.selectedTenant}`;
          this.newDocuments.push({ link: docLink, name: documentObj.fileName });
        });
        this.selectedMeeting.momDocuments =
          this.selectedMeeting.momDocuments.map(
            ({ formData, action, ...rest }) => rest
          );
      }

      if (this.selectedMeeting.generalMeetingDocs) {
        this.selectedMeeting.generalMeetingDocs.forEach((documentObj) => {
          const { formData, item, ...document } = documentObj;

          if (!documentObj.isUploaded && item) {
            const isChunkUpload = this.selectedMeeting.generalMeetingDocs.some(
              (c) => c.fileName === item.name && c.isChunkUpload === true
            );
            if (isChunkUpload) {
              addPromises.push(
                this.uploadFileInChunks(item, formData)
                  .then((res) => {
                    this.newDocumentsIds.push(documentObj.documentId);
                    const docLink = `${window.location.origin}/download/${documentObj.documentId}/tenant/${this.selectedTenant}`;
                    this.newDocuments.push({
                      link: docLink,
                      name: documentObj.fileName,
                    });
                  })
                  .catch((error) => {
                    this.selectedMeeting.generalMeetingDocs.map((f, i) => {
                      if (f.fileName == documentObj.fileName) {
                        this.selectedMeeting.generalMeetingDocs.splice(i, 1);
                      }
                    });
                    throw error;
                  })
              );
            } else {
              addPromises.push(
                this.createDocuments(formData)
                  .then((res) => {
                    this.newDocumentsIds.push(documentObj.documentId);
                    const docLink = `${window.location.origin}/download/${documentObj.documentId}/tenant/${this.selectedTenant}`;
                    this.newDocuments.push({
                      link: docLink,
                      name: documentObj.fileName,
                    });
                  })
                  .catch((error) => {
                    this.selectedMeeting.generalMeetingDocs.map((f, i) => {
                      if (f.fileName == documentObj.fileName) {
                        this.selectedMeeting.generalMeetingDocs.splice(i, 1);
                      }
                    });
                    throw error;
                  })
              );
            }
          }
        });
        let allDocs = this.selectedMeeting.generalMeetingDocs.map(
          ({ isUploaded, formData, item, isChunkUpload, ...rest }) => rest
        );
        this.selectedMeeting.generalMeetingDocs = allDocs;
        this.generalDocuments = [];
      }
      await Promise.all(addPromises);
    },
    onDeleteDocuments(id) {
      this.deleteDocumentIds.push(id);
    },
    async onUpdateMeetingData(attendees) {
      if (attendees) {
        this.selectedMeeting.attendees = attendees;
      }
      this.isMeetingDataModified = true;
      this.isDirty = true;
      this.checkFormValid(this.meetingObject);
    },
    onInterimPresentorAdd(presentor) {
      if (presentor) {
        this.selectedMeeting.interimPresentorList = presentor;
      }
      this.isMeetingDataModified = true;
      this.isDirty = true;
    },
    async saveOnApproval(topic) {
      this.emailNotificationRequired = false;
      let meetTopic = this.selectedMeeting.topics.find(
        (s) => String(s.Id).toLowerCase() === String(topic.Id).toLowerCase()
      );
      if (meetTopic) {
        if (topic.approval) {
          meetTopic.approval.isOpen = topic.approval.isOpen;
        } else {
          meetTopic.approval = { isOpen: false };
        }

        await this.updateMeeting();
      }
    },
    onChangeVoatingStatus() {
      this.skipUpdateMessage = true;
    },
    async onAddNewAgenda(agendaObjList) {
      this.newAgendaObjList = agendaObjList;
      this.isMeetingDataModified = true;
    },
    showMessageSheet(message, messageType) {
      this.displayMessage = true;
      this.message = message;
      this.messageType = messageType;
    },
    isSilentSignalR(status){
      this.isSilentRequest = status
    },
    expandCollapseLeftPane(isExpanded) {
      if (isExpanded) {
        this.$refs.splitterObj.expand(0);
      } else {
        this.$refs.splitterObj.collapse(0);
      }
    },
    async onclose() {
      this.overlay = false;
      this.navigateToOrigin();
      this.isRefreshRequired = false;
      this.meetingKey = "";
    },
    onResize() {
      this.screenHeight = window.innerHeight - 198;
    },
    async meetingNotFoundMessage(meetingID) {
      if (
        await this.$refs.confirm.open(
          this.$t("agenda.hRecordNotFound"),
          this.$t("agenda.msgNoMeetingFound", { meetingId: meetingID }),
          { noconfirm: true, dialogIcon: "alert" }
        )
      ) {
        return true;
      }
    },
    navigateToOrigin() {
      switch (this.$route.params.origin) {
        case "agenda":
          this.$router.push({
            path: "/agenda",
            query: { tab: this.agendaSelectedTab },
          });
          break;
        // case "calendar":
        //   this.$router.push("/calendar");
        //   break;
        // case "search":
        //   this.$router.push("/search");
        //   break;
        // case "dashboard":
        //   this.$router.push("/dashboard");
        //   break;
        // case "people":
        //   this.$router.push("/people");
        //   break;
        // case "landingpage":
        //   this.$router.push("/");
        //   break;
        // case "documents":
        //   this.$router.push("/documents");
        //   break;
        // case "survey":
        //   this.$router.push("/survey");
        //   break;
        // case "admin":
        //   this.$router.push("/admin");
        //   break;
        // case "activitylogs":
        //   this.$router.push("/activitylogs");
        //   break;
        default:
          // this.$router.push("/");
          this.$router.go(-1);
          break;
      }
    },
    getColor(skill) {
      switch (skill) {
        case "Management":
          return "blue";
        case "Finance and Accounting":
        case "Finance":
          return "purple lighten-2";
        case "Legal and Compliance":
        case "Legal":
          return "teal lighten-1";
        case "Global":
          return "warning darken-3";
        case "Governance":
          return "orange lighten-1";
        case "M & A and Finance":
          return "error lighten-1";
        case "IT Business":
          return "success";
        case "Human Resources and Organization":
          return "info darken-4";
      }
      return "secondary lighten-2";
    },
    dateValid(e) {
      if (e.data.value == "Empty") {
        this.isMeetingDataModified = false;
      }
      e.errorMessage = this.$t("agenda.msgDateInvalid");
    },
    meetingTimeBegin(args) {
      var date = document.getElementsByClassName("e-timepicker")[0].value;
      var regex = /^([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i;
      if (date == "") {
        this.$refs.startTimeObj.ej2Instances.value = "";
        this.isMeetingDataModified = false;
        return false;
      }
      if (!regex.test(date)) {
        document.getElementsByClassName("e-timepicker")[0].value = "";
        this.isMeetingDataModified = false;
      }
    },
    meetingStartDateTimeBegin(args) {
      const startDateValue =
        document.getElementsByClassName("e-datetimepicker")[0].value;
      const start_date = new Date(startDateValue);
      const end_date = new Date(
        this.$refs.ejsEndDateTimeObj.ej2Instances.value
      );
      if (end_date.getTime() <= start_date.getTime()) {
        const newDate = this.AddMinutesToDate(new Date(startDateValue), 5);
        this.$refs.ejsEndDateTimeObj.ej2Instances.value = newDate;
      }
    },
    meetingEndDateTimeBegin(args) {
      const endDateValue =
        document.getElementsByClassName("e-datetimepicker")[0].value;
      const start_date = new Date(
        this.$refs.ejsEndDateTimeObj.ej2Instances.value
      );
      const end_date = new Date(endDateValue);
      if (end_date.getTime() <= start_date.getTime()) {
        const date = this.AddMinutesToDate(new Date(end_date.toISOString()), 5);
        this.$refs.ejsEndDateTimeObj.ej2Instances.value = date;
      }
    },
    AddMinutesToDate(date, minutes) {
      return new Date(date.getTime() + minutes * 60000);
    },
    uploadMeetingDescriptionImages,
    bindMeetingDecriptionImages,
    uploadImage,
    processImageTag,
    updateImageTag,
    deleteImageDocuments,
  },
};

async function bindMeetingDecriptionImages() {
  let htmlContent = this.selectedMeeting.description;
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");
  var imgElements = doc.querySelectorAll("img");
  var imgTags = [];
  imgElements.forEach(function (img) {
    imgTags.push(img);
  });
  for (const imgTag of imgTags) {
    let imgSrc = imgTag.getAttribute("src");
    if (imgSrc && imgSrc.startsWith("IMAGE_")) {
      const guid = imgSrc.split("IMAGE_")[1];
      const imgData = this.selectedMeeting.description_meta.find(
        (i) => i.documentId === guid
      );
      if (imgTag && imgData) {
        imgTag.src = `${imgData.encoded_image}`;
        imgTag.setAttribute("id", imgData.documentId);
      }
    }
  }

  htmlContent = doc.body.innerHTML;
  return htmlContent;
}

async function uploadMeetingDescriptionImages() {
  try {
    let htmlContent = this.selectedMeeting.description;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, "text/html");
    const imgTags = Array.from(doc.querySelectorAll("img")); // Collect img tags as an array
    if (!this.selectedMeeting.description_meta) {
      this.selectedMeeting.description_meta = [];
    }
    let description_meta = [...this.selectedMeeting.description_meta];
    let existingDocIds = [];

    // Process all img tags
    for (const imgTag of imgTags) {
      await this.processImageTag(imgTag, description_meta, existingDocIds);
    }

    htmlContent = doc.body.innerHTML; // Update htmlContent with the modified src values

    const deletedIds = getDeletedIds(description_meta, existingDocIds);
    const restArray = filterAndRemoveEncodedImage(
      description_meta,
      existingDocIds
    );

    // Handle deletion of removed image documents
    if (deletedIds.length) {
      if (!this.isMeetingRecurrence) {
        await this.deleteImageDocuments(deletedIds);
      }
      this.existingDocIds = [];
    }

    // Update description_meta and description
    this.selectedMeeting.description_meta = restArray;
    this.selectedMeeting.description = htmlContent;
  } catch (error) {
    console.error("Error fetching the Blob:", error);
  }
}

// Process each image tag to handle file upload or ID assignment
async function processImageTag(imgTag, description_meta, existingDocIds) {
  const imgSrc = imgTag.getAttribute("src");

  // Process external image URLs (not starting with IMAGE_ or data:)
  if (imgSrc && !imgSrc.startsWith("IMAGE_") && !imgSrc.startsWith("data:")) {
    const documentId = await this.uploadImage(imgSrc);
    if (documentId) {
      this.updateImageTag(imgTag, documentId, description_meta, existingDocIds);
    }
  }
  // Handle base64 images
  else if (imgSrc.startsWith("data:") && imgTag.hasAttribute("id")) {
    const documentId = imgTag.id;
    imgTag.src = `IMAGE_${documentId}`;
    existingDocIds.push(documentId);
  }
}

// Upload an image, create a File object, and return the document ID
async function uploadImage(imgSrc) {
  const response = await fetch(imgSrc);
  const blob = await response.blob();
  const fileType = blob.type;
  const isImage = fileType.startsWith("image/");
  if (isImage) {
    const fileTypeExt = fileType.substring(fileType.indexOf("/") + 1);
    const file = new File([blob], `DiscriptionImage.${fileTypeExt}`, {
      type: fileType,
    });

    const documentId = createUUID();
    const formData = new FormData();

    formData.append("tenantId", this.selectedTenant);
    formData.append("topicId", "");
    formData.append("meetingId", this.meetingObject.id);
    formData.append("agendaId", "");
    formData.append("directoryId", "");
    formData.append("peopleId", "");
    formData.append("file", file);
    formData.append("documentId", documentId);
    formData.append("chunk_upload", false);
    formData.append("filename", file.name);
    formData.append("content_type", file.type);
    formData.append("document_type", "description_image");

    await this.createDocuments(formData); // Upload the image
    return documentId;
  }
  return null;
}

// Update the image tag's src attribute and track document metadata
function updateImageTag(imgTag, documentId, description_meta, existingDocIds) {
  imgTag.src = `IMAGE_${documentId}`;
  description_meta.push({ documentId });
  existingDocIds.push(documentId);
}

// Get the IDs of images that were removed from the updated document list
function getDeletedIds(description_meta, existingDocIds) {
  return description_meta
    .filter((item) => !existingDocIds.includes(item.documentId))
    .map((item) => item.documentId);
}

// Filter the description_meta array and remove the encoded_image key
function filterAndRemoveEncodedImage(description_meta, existingDocIds) {
  return description_meta
    .filter((item) => existingDocIds.includes(item.documentId))
    .map(({ encoded_image, ...rest }) => rest);
}

// Handle deletion of documents using their IDs
async function deleteImageDocuments(deletedIds) {
  const promises = deletedIds.map((id) => this.deleteDocuments(id));
  await Promise.all(promises);
}

function onStartDateChange(event) {
  const date = new Date(event.value);
  if (this.meetingObject.scheduledEndTimeInUTC.getTime() <= date.getTime()) {
    const newDate = this.AddMinutesToDate(new Date(date), 5).toISOString();
    this.meetingObject.scheduledEndTimeInUTC = newDate;
  }
}

function onEndDateChange(event) {
  const endDate = new Date(event.value);
  let date = endDate;
  if (
    endDate.getTime() <= this.meetingObject.scheduletStartTimeInUTC.getTime()
  ) {
    date = this.AddMinutesToDate(
      new Date(endDate.toISOString()),
      5
    ).toISOString();
  }
  this.meetingObject.scheduledEndTimeInUTC = date;
}

function roundTimeQuarterHour(time) {
  var timeToReturn = new Date(time);

  timeToReturn.setMilliseconds(
    Math.round(timeToReturn.getMilliseconds() / 1000) * 1000
  );
  timeToReturn.setSeconds(Math.round(timeToReturn.getSeconds() / 60) * 60);
  timeToReturn.setMinutes(Math.round(timeToReturn.getMinutes() / 15) * 15);
  return timeToReturn;
}
</script>